import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Menu,
  MenuItem,
  IconButton,
  Typography,
  useMediaQuery,
  makeStyles,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  trigger: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  label: {
    flex: 1,
    fontWeight: 500,
  },
}));

export function FilterSelector(props) {
  const { options, selectedOption, onHandleSelectOption,disabled, ...rest } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs")); // ≤600px

  const [anchorEl, setAnchorEl] = useState(null);
  const [checked, setChecked] = useState(false);

  const handleOpenMenu = (event) => {
    if(disabled) return
    if (document.activeElement) document.activeElement.blur(); // ✅ quita foco
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectOption = (option) => {
    onHandleSelectOption(option);
    setChecked(true); // ✅ Se activa automáticamente al elegir
    handleCloseMenu();
  };

  const handleCheckboxToggle = (checked) => {
    // ✅ Solo permite activarlo si hay una opción elegida
    if (!checked) onHandleSelectOption("");
    if (!selectedOption) return;
    setChecked((prev) => !prev);
  };
  useEffect(() => {
    return () => {
      onHandleSelectOption("");
    };
  }, []);
  return (
    <>
      {/* Trigger */}
      <div className={classes.trigger} onClick={handleOpenMenu} >
        <Checkbox
          checked={checked}
          onClick={(e) => {
            e.stopPropagation(); // Evita abrir menú
            handleCheckboxToggle(e.target.checked);
          }}
          style={{ color: "inherit" }}
        />

        {/* En mobile mostramos etiqueta */}
        {isMobile && (
          <Typography className={classes.label}>
            {options.find((opt) => opt.value === selectedOption)?.label ||
              "Seleccionar"}
          </Typography>
        )}

        {/* Ícono flecha siempre visible */}
        <IconButton size="small" color="inherit">
          <ArrowDropDownIcon />
        </IconButton>
      </div>

      {/* Menu opciones */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === selectedOption}
            onClick={() => handleSelectOption(option.value)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
